import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, SortDirection, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import invoiceService from "../services/invoice-service";
import moment from "moment";
const tablePropsInit = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Facility ID"},
    { key: "year", title: "Year" },
    { key: "month", title: "Month", sortDirection: SortDirection.Descend },
    { key: "created_at", title: "Created On" },
    { key: "file_path", title: "Download" }
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const InvoiceList = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState("hidden");
  const { register, getValues } = useForm({});
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [rows, setRows] = useState([]);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  async function getInvoiceList() {
    let massinvoice_year = getValues("invoice_list_year");
    let massinvoice_month = getValues("invoice_list_month");
    try {      
      setLoading(true);
      let params = {
        year: massinvoice_year,
        month: massinvoice_month
      };
      let resp = await invoiceService.getInvoices(params);
      if (resp.length > 0) {
        setShowList("show");
        dispatch(updateData(resp));
        setRows(resp)
      } else {
        setShowList("hidden");
        dispatch(updateData([]));
        setRows([])
        const { hide } = cogoToast.error("No Records Found!", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);    
    }
  } 
  const downloadReport = async (id) => {
    try {
      setLoading(true);
      let pdfData = await invoiceService.reportDownload(id);
      const linkSource = `data:application/pdf;base64,${pdfData}`;
      const downloadLink = document.createElement("a");
      const fileName = "invoice.pdf";  
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
    
  }; 
  const CustomCell = ({rowData}) => {
    return (
      <div>    
          <span className="inline-block mr-3">{moment.utc(rowData?.created_at).format('MM-DD-YYYY') || ''}</span>          
      </div>
    );
  };
  const disableXMLDownload = (id,  value) =>{
    const rowIndex = rows.findIndex((row) => row.id === id);
    if(rowIndex !== -1) {
      rows[rowIndex].disableXMLDownload = value;
      setRows(rows)
      dispatch(updateData(rows));
    }
  }
  const disablePdfDownload = (id,  value) =>{
    const rowIndex = rows.findIndex((row) => row.id === id);
    if(rowIndex !== -1) {
      rows[rowIndex].disablePdfDownload = value;
      setRows(rows)
      dispatch(updateData(rows));
    }
  }
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        <a
          href={rowData.file_path}
          download="Invoice.xlsx"
          className={rowData.disableXMLDownload ? "inline-block pointer-events-none opacity-50 cursor-not-allowed" : "inline-block"}
          onClick={() => {
            disableXMLDownload(rowData.id, true);
            setTimeout(() => disableXMLDownload(rowData.id,false), 30000);
          }}
        >
          <img src="/img/downloadxlsx.svg" alt="" className="w-6 h-7" />
        </a>
        <button disabled={rowData.disablePdfDownload}
          onClick={(e) => {
            disablePdfDownload(rowData.id, true);
            setTimeout(() => disablePdfDownload(rowData.id,false), 30000);
            downloadReport(
              rowData.id
            );
          }}
          download="Invoice.pdf"
          className={rowData.disablePdfDownload ? "opacity-50 cursor-not-allowed inline-block mx-8" : "inline-block mx-8"}
        >
          <img src="/img/downloadpdf.svg" alt="" className="w-6 h-7" />
        </button>
      </div>
    );
  };
  const CustomCell4 = ({ rowData }) => {
    return (
      <div>
        <span>{rowData?.group ? rowData.group : rowData.unique}</span>
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        <span>{moment.monthsShort(rowData.month - 1)}</span>
      </div>
    );
  };
  const totalYears = () => {
    const years = []
    const dateStart = moment().subtract(1,'y')
    const dateEnd = moment().add(1, 'y')
    while (dateEnd.diff(dateStart, 'years') >= 0) {
      years.push(dateStart.format('YYYY'))
      dateStart.add(1, 'year')
    }
    return years
   }
   const totalYearsList = () => {     
       return (
        totalYears().map((i)=><option value={i} key={i}>{i}</option>)
       );
   };
   const totalMonthsList = () =>{
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
    return (
      months.map((i, index)=><option value={index + 1} key={i}>{i}</option>)
     );
   }
   useEffect(() => {
    getInvoiceList();    
  }, []);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-11/12 sm:w-10/12 mx-auto mt-12 mb-4">
        <div className="tableHeader flex clearboth shadow-md pt-3 pr-5 pb-3 pl-7">
          <div className="w-1/2 text-darkclr font-semibold leading-8">
            INVOICE LIST
          </div>
          
          <div className="w-full sm:w-1/2 text-right">
          <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 top-1 bottom-3"
              ></img>
            </span>
            <span>
            <select
                  name="invoice_list_year"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={moment().format('YYYY')}
                  onChange={() => {
                    getInvoiceList();
                  }}
                  aria-label="Select Report Year"
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-100"
                >
                  <option value="0">Select Year</option>
                  {totalYearsList()}                      
                </select>
            </span>
            <span className="pl-2">
            <select
                  name="invoice_list_month"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={moment().format('MMM')}
                  onChange={() => {
                    getInvoiceList();
                  }}
                  aria-label="Select Report Month"
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/5 "
                >
                  <option value="0">Select Month</option>
                  {totalMonthsList()}                      
                </select>
            </span>
            
          </div>
        </div>
        <div className={`pt-5 pb-5 text-xs patientDetails overflow-x-auto ${showList} `}>
          <Table {...tableProps} 
          childComponents={{
            cellText: {
              content: (props) => {
                // eslint-disable-next-line default-case
                switch (props.column.key){
                  case "group":
                         return <CustomCell4 {...props} />;
                  case 'created_at': return <CustomCell {...props}/>;  
                  case 'file_path': return <CustomCell1 {...props}/>;   
                  case "month":
                        return <CustomCell2 {...props} />;
                               
                }
              }
            }
          }}
          dispatch={dispatch} />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(InvoiceList)
);
